import {createStore, applyMiddleware, combineReducers, compose} from 'redux';
import thunk from 'redux-thunk';
import {reducer as homeReducer} from '../pages/home/store';
import {reducer as venueReducer} from '../pages/space/store';
import {reducer as venueInfoReducer} from '../pages/spaceInfo/store';
import {reducer as userChargeReducer} from '../pages/myCharge/store';
import {reducer as userInfoReducer} from '../pages/my/store';
import {reducer as orderListReducer} from '../pages/myOrder/store';
import {reducer as spaceListReducer} from '../pages/spaceList/store';
import {reducer as createOrderReducer} from '../pages/order/store';
import {reducer as payReducer} from '../pages/pay/store';
import {reducer as modifyReducer} from '../pages/modify/store';
import {reducer as consumeReducer} from '../pages/myConsume/store';

const middlewares = [];
const reducer = combineReducers({
    // user: userReducer,
    home: homeReducer,
    venue: venueReducer,
    venueDetail: venueInfoReducer,
    userChargeList: userChargeReducer,
    userInfo: userInfoReducer,
    orderList: orderListReducer,
    spaceList: spaceListReducer,
    createOrder: createOrderReducer,
    pay: payReducer,
    modify: modifyReducer,
    consume: consumeReducer,
    // masters: mastersReducer,
    // bank: bankCardReducer,
    // withdraw: withdrawCardReducer,
    // cart: cartCardReducer,
    // community:communityReducer,
    // search:searchReducer,
    // releaseMaster:releaseMasterReducer,
});

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;
// middlewares.push(logger);
middlewares.push(thunk);

const enhancer = composeEnhancers(applyMiddleware(...middlewares))
const store = createStore(reducer,
    enhancer
);
export default store;